export const OptionChips = ({ label, options, value, onChange, testid }) => (
  <div>
    <p className="text-[11px] font-semibold uppercase tracking-wide text-[#73706A] mb-1.5">
      {label}
      {!value && <span className="ml-1 normal-case font-medium text-[#E85D04]">— escolha</span>}
    </p>
    <div className="flex flex-wrap gap-1.5">
      {options.map((o, i) => (
        <button
          type="button"
          key={o}
          onClick={() => onChange(o)}
          className={`min-w-[40px] h-8 px-2.5 rounded-md border text-xs font-medium transition-colors duration-150 ${
            value === o
              ? 'bg-[#1A1A1A] text-white border-[#1A1A1A]'
              : 'bg-white text-[#1A1A1A] border-[#E6E2D8] hover:border-[#E85D04]'
          }`}
          data-testid={`${testid}-${i}`}
        >
          {o}
        </button>
      ))}
    </div>
  </div>
);

// Valor padrao: so pre-seleciona quando existe uma unica opcao
export const autoPick = (options) => (options && options.length === 1 ? options[0] : '');

export const missingOption = (product, size, color) => {
  if (product?.sizes?.length && !size) return `Escolha o tamanho de ${product.name || product.product_name}`;
  if (product?.colors?.length && !color) return `Escolha a cor de ${product.name || product.product_name}`;
  return null;
};
